var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoOthers16X16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-chart",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48364",
    "data-name": "Path 48364",
    d: "M14,1H2A2.1,2.1,0,0,0,0,3.182V14.818A2.1,2.1,0,0,0,2,17H14a2.1,2.1,0,0,0,2-2.182V3.182A2.1,2.1,0,0,0,14,1Zm0,14.545H2a.7.7,0,0,1-.667-.727V4.636H14.667V14.818A.7.7,0,0,1,14,15.545Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "settings_1_",
    "data-name": "settings (1)",
    transform: "translate(2.399 5.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29060",
    "data-name": "Group 29060",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48360",
    "data-name": "Path 48360",
    d: "M4.63,180.448A.448.448,0,0,0,4.183,180H2.394a.448.448,0,0,0-.447.448v.8H0v.9H1.946v.765a.448.448,0,0,0,.447.448h1.79a.448.448,0,0,0,.447-.448v-.765h6.823v-.9H4.63Z",
    transform: "translate(0 -176.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48361",
    "data-name": "Path 48361",
    d: "M9.641,362.448A.448.448,0,0,0,9.194,362H7.4a.448.448,0,0,0-.447.448v.785H0v.9H6.957v.785a.448.448,0,0,0,.447.448h1.79a.448.448,0,0,0,.447-.448v-.785h1.812v-.9H9.641Z",
    transform: "translate(0 -355.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48362",
    "data-name": "Path 48362",
    d: "M9.686,1.256V.448A.448.448,0,0,0,9.239,0H7.449A.448.448,0,0,0,7,.448v.807H0v.9H7v.762a.448.448,0,0,0,.447.448h1.79a.448.448,0,0,0,.447-.448V2.153h1.767v-.9Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoOthers16X16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_others16x16.659948f4720e333750907bef06288adb.svg";